import React, { useEffect, useState } from "react";
import CommonNoteModal from "../../../features/order/modal/CommonNoteModal";
import { handleRTKQuery } from "../../../helpers/utils/RtkQueryUtils";
import { useCreateCertificateNoteMutation, useUpdateCertificateNoteMutation } from "./CertificateNotesApi";
import { useCreateCannedNoteMutation } from "../../../features/data/cannedNotes/cannedNotesApi";
import {
    useCreateSubdivisionChildAccountNoteServiceMutation,
    useCreateSubdivisionNoteServiceMutation,
    useUpdateSubdivisionChildAccountNoteServiceMutation,
    useUpdateSubdivisionNoteServiceMutation
} from "../../../features/data/subDivision/subDivisionApi";

interface CertNoteAddOrUpdateModalProps {
    show: boolean;
    title: string;
    setShow: (show: boolean) => void;
    noteObj?: any;
    type: string;
    relationalId: any;
    btnName: string;
    isFulfillmentNotes?: boolean;
    parentAccountData?: any;
    length?: number;
    actionType?: any;
}

const CertNoteAddOrUpdateModal: React.FC<CertNoteAddOrUpdateModalProps> = ({
    show,
    title,
    setShow,
    noteObj = null,
    type,
    relationalId,
    btnName,
    isFulfillmentNotes = false,
    parentAccountData = null,
    length = 1,
    actionType
}: CertNoteAddOrUpdateModalProps) => {
    const [noteBody, setNoteBody] = useState<string>("");
    const [targetCert, setTargetCert] = useState<any>({ label: "Both", value: "BOTH" });
    const [disable, setDisable] = useState<boolean>(false);
    const [saveAsCanned, setSaveAsCanned] = useState<boolean>(false);
    const [yellowHighlight, setYellowHighlight] = useState<boolean>(false);
    const [redColor, setRedColor] = useState<boolean>(false);
    const [isBold, setIsBold] = useState<boolean>(false);
    const [accountNumber, setAccountNumber] = useState<any>(null);
    const [sortIndex, setSortIndex] = useState<number>(length);
    const [createNote, createNotesApiRes] = useCreateCertificateNoteMutation();
    const [updateNote, updateNotesApiRes] = useUpdateCertificateNoteMutation();
    const [createSubdivisionNotesApi, createSubdivisionNotesApiRes] = useCreateSubdivisionNoteServiceMutation();
    const [updateSubdivisionNotesApi, updateSubdivisionNotesApiRes] = useUpdateSubdivisionNoteServiceMutation();

    const [createSubdivisionChildAccountNotesApi, createSubdivisionChildAccountNotesApiRes] = useCreateSubdivisionChildAccountNoteServiceMutation();
    const [updateSubdivisionChildAccountNotesApi, updateSubdivisionChildAccountNotesApiRes] = useUpdateSubdivisionChildAccountNoteServiceMutation();

    const [createCannedNote] = useCreateCannedNoteMutation();

    useEffect(() => {
        if (noteObj !== null) {
            setNoteBody(noteObj?.message !== undefined ? noteObj?.message : noteObj?.comment);
            setAccountNumber(noteObj?.accountNumber !== undefined ? {
                label: noteObj?.accountNumber, value: noteObj?.accountNumber
            } : null);
            setSortIndex(noteObj?.sort !== undefined ? noteObj?.sort : null);
            setIsBold(noteObj?.bold !== undefined ? noteObj?.bold : null);
            setTargetCert(noteObj?.targetCert !== undefined ? {
                label: noteObj?.targetCert,
                value: noteObj?.targetCert
            } : null);
            setRedColor(noteObj?.redColor !== undefined ? noteObj?.redColor : null);
            setYellowHighlight(noteObj?.yellowHighlight !== undefined ? noteObj?.yellowHighlight : null);
        }
    }, [noteObj]);

    const noteDto = {
        comment: noteBody,
        relationalId: relationalId,
        type: type,
        accountNumber: accountNumber?.value,
        sort: sortIndex,
        yellowHighlight: yellowHighlight,
        redColor: redColor,
        bold: isBold,
        visible: true,
        targetCert: targetCert?.value
    };

    function dismissModal(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        setShow(false);
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (noteBody) {
            setDisable(true);

            if (actionType === "SubdivisionResearch") {
                if (btnName !== "Update") {
                    await handleRTKQuery(
                        async () => {
                            return await createSubdivisionNotesApi(
                                {
                                    id: relationalId,
                                    requestBody: noteDto
                                }
                            ).unwrap();
                        },
                        (isSuccess: boolean) => {
                            if (isSuccess) {
                                setShow(false);
                            }
                        }
                    );
                } else {
                    let obj = {
                        comment: noteBody,
                        subdivisionId: relationalId,
                        type: type,
                        sort: sortIndex,
                        yellowHighlight: yellowHighlight,
                        redColor: redColor,
                        bold: isBold,
                        visible: true,
                        targetCert: targetCert?.value
                    };
                    await handleRTKQuery(
                        async () => {
                            return await updateSubdivisionNotesApi({ id: noteObj.id, requestBody: obj }).unwrap();
                        },
                        (isSuccess: boolean) => {
                            if (isSuccess) {
                                setShow(false);
                            }
                        }
                    );
                }
            }
            else if (actionType === "SubdivisionChild") {
                if (btnName !== "Update") {
                    await handleRTKQuery(
                        async () => {
                            return await createSubdivisionChildAccountNotesApi(
                                {
                                    id: relationalId,
                                    requestBody: noteDto
                                }
                            ).unwrap();
                        },
                        (isSuccess: boolean) => {
                            if (isSuccess) {
                                setShow(false);
                            }
                        }
                    );
                } else {
                    let obj = {
                        comment: noteBody,
                        subdivisionId: relationalId,
                        type: type,
                        sort: sortIndex,
                        yellowHighlight: yellowHighlight,
                        redColor: redColor,
                        bold: isBold,
                        visible: true,
                        targetCert: targetCert?.value
                    };
                    await handleRTKQuery(
                        async () => {
                            return await updateSubdivisionChildAccountNotesApi({ id: noteObj.id, requestBody: obj }).unwrap();
                        },
                        (isSuccess: boolean) => {
                            if (isSuccess) {
                                setShow(false);
                            }
                        }
                    );
                }
            }
            else {
                if (btnName !== "Update") {
                    await handleRTKQuery(
                        async () => {
                            return await createNote(noteDto).unwrap();
                        },
                        (isSuccess: boolean) => {
                            if (isSuccess) {
                                setShow(false);
                            }
                        }
                    );
                } else {
                    let obj = {
                        comment: noteBody,
                        accountNumber: accountNumber?.value,
                        relationalId: relationalId,
                        type: type,
                        sort: sortIndex,
                        yellowHighlight: yellowHighlight,
                        redColor: redColor,
                        bold: isBold,
                        visible: true,
                        targetCert: targetCert?.value
                    };
                    await handleRTKQuery(
                        async () => {
                            return await updateNote({ noteId: noteObj.id, obj: obj }).unwrap();
                        },
                        (isSuccess: boolean) => {
                            if (isSuccess) {
                                setShow(false);
                            }
                        }
                    );
                }
            }
            if (saveAsCanned) {
                setDisable(true);
                if (saveAsCanned) {
                    try {
                        setDisable(true);
                        await createCannedNote({
                            comment: noteBody,
                            bold: isBold,
                            type: type,
                            yellowHighlight,
                            redColor,
                            sort: sortIndex
                        }).unwrap();
                    } catch (error) {
                        console.error("Error saving canned note:", error);
                    } finally {
                        setDisable(false);
                    }
                }
            }

        }
    }

    return (
        <>
            <CommonNoteModal
                targetCert={targetCert}
                setTargetCert={setTargetCert}
                noteBody={noteBody}
                title={title}
                setShow={setShow}
                show={show}
                setNoteBody={setNoteBody}
                onSubmit={handleSubmit}
                dismissModal={dismissModal}
                disable={disable}
                type={type}
                saveAsCanned={saveAsCanned}
                setSaveAsCanned={setSaveAsCanned}
                isCertificateNote={true}
                yellowHighlight={yellowHighlight}
                setYellowHighlight={setYellowHighlight}
                redColor={redColor}
                setRedColor={setRedColor}
                bold={isBold}
                setBold={setIsBold}
                btnName={btnName}
                isFulfillmentNotes={isFulfillmentNotes}
                accountNumber={accountNumber}
                setAccountNumber={setAccountNumber}
                parentAccountData={parentAccountData}
                sort={sortIndex}
                setSort={setSortIndex}
                isLoading={createNotesApiRes.isLoading || updateNotesApiRes.isLoading || createSubdivisionNotesApiRes.isLoading || updateSubdivisionNotesApiRes.isLoading
                    || createSubdivisionChildAccountNotesApiRes.isLoading || updateSubdivisionChildAccountNotesApiRes.isLoading
                }
            />


        </>
    );
};

export default CertNoteAddOrUpdateModal;
